import Swiper, { Navigation } from 'swiper'
import ReadingCoachModal from './reading_coach_modal'

const SELECTORS = {
  swiper: '.js-reading-coach-carousel',
  swiperSlideWrapper: '.js-swiper-wrapper',
  modals: '.js-reading-coach-modal',
  announcer: '.js-slide-announcer',
  navNext: '#swiper-next-js-reading-coach-carousel',
  navPrev: '#swiper-prev-js-reading-coach-carousel'
}

Swiper.use([Navigation])

class ReadingCoachCarousel {
  constructor (element) {
    this.element = element
    this.navNext = this.element.querySelector(SELECTORS.navNext)
    this.navPrev = this.element.querySelector(SELECTORS.navPrev)
    this.carouselWrapper = this.element.querySelector(SELECTORS.swiperSlideWrapper)
    this.announcer = this.element.querySelector(SELECTORS.announcer)
    this.modals = [...document.querySelectorAll(SELECTORS.modals)]
    this.carousel = null

    this.init()
  }

  init() {
    this.createCarousel()
    this.modals.forEach(modal => {
      const obj = new ReadingCoachModal(modal)
      if (!('parent' in modal.dataset)) {
        obj.onClose = (modal) => {
          const button = [...this.element.querySelectorAll(`.swiper-slide .js-reading-coach-modal-button[data-target="${modal.id}"]`)]
          // const slide = button.closest('.swiper-slide')
          // this.carousel.slideTo(parseInt(slide.dataset.swiperSlideIndex), 0, true)
          button[1].focus()
          this.element.scrollLeft = 0
        }
      }
    })
  }

  createCarousel() {
    this.carousel = new Swiper(this.element, {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      shortSwipes: false,
      a11y: {
        scrollOnFocus: false,
        nextSlideMessage: 'Next book',
        prevSlideMessage: 'Previous book',
        slideLabelMessage: 'Book {{index}} of {{slidesLength}}'
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      freeMode: {
        enabled: true,
        sticky: true,
        momentumBounce: false
      },
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev
      },
      init: false,
      breakpoints: {
        768: {
          slidesPerView: 2.1
        }
      }
    })

    // Play video from the beginning when it animates in and when Swiper loads
    this.carousel.on('afterInit', (swiper) => {
      this.element.classList.remove('carousel--hidden')
      this.playActiveVideo(swiper)
    })

    this.carousel.on('activeIndexChange', (swiper) => {
      this.playActiveVideo(swiper)
    })

    this.carousel.on('realIndexChange', (swiper) => {
      this.announcer.innerHTML = `Book ${swiper.realIndex + 1} of ${swiper.loopedSlides}`
    })

    this.carousel.on('transitionEnd', (swiper) => {
      swiper.slides.forEach(slide => {
        const button = slide.querySelector('.js-reading-coach-modal-button')
        if (slide.classList.contains('swiper-slide-active')) {
          slide.ariaHidden = 'false'
          button.tabIndex = 0
        } else {
          slide.ariaHidden = 'true'
          button.tabIndex = -1
        }
      })
    })

    this.element.addEventListener('click', ({ target }) => {
      const slide = target.closest('.swiper-slide:not(.swiper-slide-active)')
      if (!slide) return

      this.navigateToSlide(slide)
    })

    this.carouselWrapper.addEventListener('keydown', (event) => {
      const navigationKeys = ['ArrowLeft', 'ArrowRight']
      if (!navigationKeys.includes(event.key)) return

      event.preventDefault()

      const buttons = [...this.element.querySelectorAll('.js-reading-coach-modal-button')]
      buttons.forEach(button => button.blur())

      switch (event.key) {
        case 'ArrowLeft':
          this.carousel.slidePrev(250, true)
          break
        case 'ArrowRight':
          this.carousel.slideNext(250, true)
          break
      }

      setTimeout(() => {
        this.element.querySelector('.swiper-slide-active .js-reading-coach-modal-button').focus()
      }, 275)
    })

    this.carousel.init()
  }

  // Convoluted logic inside. Because Swiper creates duplicate slides, sometimes
  // when just passing an index to slideToLoop, Swiper will slide to the
  // original instead of the copy clicked. The extra logic here determines if
  // you're clicking the next or previous slide, and uses the appropriate
  // slideNext or slidePrev function, which understands duplication better.
  navigateToSlide = (slide) => {
    const totalSlides = this.carousel.loopedSlides
    const currentIndex = this.carousel.realIndex
    const clickedIndex = parseInt(slide.dataset.swiperSlideIndex)
    const previousIndex = (currentIndex + totalSlides - 1) % totalSlides
    const nextIndex = (currentIndex + 1) % totalSlides

    if (clickedIndex === nextIndex) {
      this.carousel.slideNext(500, true)
    } else if (clickedIndex === previousIndex) {
      this.carousel.slidePrev(500, true)
    } else if (clickedIndex !== this.carousel.realIndex) {
      this.carousel.slideToLoop(parseInt(slide.dataset.swiperSlideIndex), 500, true)
    }
  }

  playActiveVideo = (swiper) => {
    const currentVideo = swiper.slides[swiper.activeIndex].querySelector('video')
    if (!currentVideo) return

    currentVideo.currentTime = 0
    if (!document.documentElement.classList.contains('reduced-motion')) {
      currentVideo.play()
    }
  }
}

export default {
  selector: '.js-reading-coach-carousel',
  Source: ReadingCoachCarousel
}
